import ApplicationController from 'javascript/controllers/application_controller';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends ApplicationController {
  visitEvent({ target: { value } }) {
    Turbo.visit(`?event_slug=${value}`);
  }
}
